import type { ReactNode } from "react";
import { C } from "../tokens";

interface Props {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12,
        padding: 40,
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: 48, height: 48,
          borderRadius: 16,
          background: C.blueDim,
          border: `1px solid ${C.borderBright}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          color: C.blue,
        }}
      >
        {icon}
      </div>
      <div style={{ color: C.text, fontSize: 14, fontWeight: 600 }}>{title}</div>
      {description && (
        <div style={{ color: C.textMuted, fontSize: 12, maxWidth: 320 }}>{description}</div>
      )}
      {action}
    </div>
  );
}
